import React, { SVGProps } from 'react'

import { overrideOptional } from '@emico/overrides'

const ArrowLeftIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 2643.9 491.8"
    width="1em"
    height="1em"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M148,313.8c0,61.6,12,67.2,72.7,67.2h97.4c51.9,0,73.4-4,80.6-39.2l127,6.4c-21.6,102.2-75.8,140.5-190,140.5
H203.1c-67.1,0-108.6-12.8-138.9-43.9C33,416.1,21.1,375.3,21.1,306.7V186.9c0-69.5,12-108.6,43.1-138.9C95.3,16.8,136,4,203.1,4
h133.4c67.9,0.8,108.6,13.6,139.7,43.1c31.1,30.3,43.1,67.1,43.1,138.9v112.6H148V313.8z M391.6,198v-15.2c0-65.5-12-71.3-72.7-71.3
h-97.4c-60.7,0-72.7,5.9-72.7,71.3V198H391.6z"
    />
    <path
      d="M1238.1,183.1c0-67.2-11.4-71.7-74.5-71.7h-28.7c-63.1,0-78.8,4.5-78.8,71.7v305.6H927.4V183.1
c0-67.2-9.7-71.7-69.6-71.7h-113v377.3H616.4V4h223c75.9,0,115,14.4,148.5,54.3C1021.5,18.4,1061.4,4,1138.9,4h43.3
c70.3,0,110.2,12.8,141.3,43.9s43.1,70.3,43.1,138.2v302.7h-128.6V183.1z"
    />
    <path d="M1462.6,4H1592v484.7h-129.5V4z" />
    <path
      d="M2026.8,379.3h-138.2c-59.9,0-71.7-5.9-71.7-65.8V183.1c0-67.2,11.8-70.7,72.5-70.7h137.4V4h-150.1
c-67.9,0-114.5,12.8-144.9,43.9c-31.1,30.3-43.1,68-43.1,134.2v130.5c0,62,12,102.7,43.1,132.2c31.1,31.1,77,43.9,144.9,43.9h150.1
V379.3z"
    />
    <path
      d="M2585,47.7c-31.1-31-71-43.7-139.6-43.7h-67h-67c-68.6,0-108.5,12.7-139.6,43.7c-31.1,30.2-51,68.7-51,136.3
v129.7c0,61,19.9,101.2,51,131.4c31.1,31,71,43.7,139.6,43.7h67h67c68.6,0,108.5-12.7,139.6-43.7c31.1-30.2,51-70.3,51-131.4V184
C2636,116.4,2616.2,77.9,2585,47.7z M2506.9,313.7c0,61-12.8,66.2-74.2,66.2h-54.2h-54.2c-61.4,0-74.2-5.2-74.2-66.2V184
c0-67.6,12.8-72.1,73.4-72.1h54.8h0.4h54.8c60.6,0,73.4,4.5,73.4,72.1V313.7z"
    />
  </svg>
)

export default overrideOptional(ArrowLeftIcon)
